module.exports = __webpack_public_path__ + "static/media/icon-chevron-left-circle.02252f6d.svg";